import axios from 'axios';
import fetch from '../../auth/FetchInterceptor';

export const login = function (data) {
  return fetch({
    url: '/auth/login',
    method: 'post',
    headers: {
      'public-request': 'true',
    },
    data: data,
  });
};

export const user = function (data) {
  return fetch({
    url: '/auth/user',
    method: 'get',
    data: data,
  });
};

export const logout = function () {
  return fetch({
    url: '/auth/logout',
    method: 'post',
  });
};

export const register = function (data) {
  return fetch({
    url: '/auth/signup',
    method: 'post',
    headers: {
      'public-request': 'true',
    },
    data: data,
  });
};

export const invitation_register = function (data) {
  return fetch({
    url: '/auth/invitation_signup',
    method: 'post',
    headers: {
      'public-request': 'true',
    },
    data: data,
  });
};

export const updateCurrentUser = function (data) {
  return fetch({
    url: `/auth/user`,
    method: 'put',
    data: data,
  });
};

export const updateCurrentPassword = function (data) {
  return fetch({
    url: `/auth/password`,
    method: 'put',
    data: data,
  });
};

export const updateSearchToken = () => {
  return fetch({
    url: `/auth/search_token`,
    method: 'post',
  });
};

export const completeTutorial = (id) => {
  return fetch({
    url: `/auth/complete_tutorial`,
    method: 'post',
    data: {
      tutorial_id: id,
    },
  });
};

export const requestPasswordReset = (email) => {
  return axios.post(`${process.env.REACT_APP_API_URL}auth/send?email=${email}`);
};

export const resetPassword = (token, email, password, confirmation) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}auth/reset?token=${token}&email=${email}&password=${password}&password_confirmation=${confirmation}`
  );
};
